import { createFileRoute } from '@tanstack/react-router'
import RegistroChavesSplitPage from '@/pages/chaves/registro-chaves-split-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/chaves',
)({
  component: function ChavesListRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.REGISTRO_CHAVES} dashboardId={dashboardId}>
        <ProtectedRoute
          anyOf={[CAPABILITIES.KEYS_OWN, CAPABILITIES.KEYS_ALL]}
          dashboardId={dashboardId}
        >
          <RegistroChavesSplitPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
